// @flow

export const ITEM_MARGIN = 8
export const CHECKLIST_MIN_NAME_WIDTH = 30
export const CHECKLIST_WIDTH = 65
export const CHECKLISTS_MORE_WIDTH = 25
